<template>
  <div class="custom-table">
    <div v-if="departments" class="table-responsive" style="min-height: 60vh;">
      <table class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800">
        <thead>
        <tr class="align-middle bg-gray-100i">
          <td colspan="5" class="text-center">
            <div
                @click="openModel(null, null, false)"
                class="rounded border border-dashed pt-6 pb-6 cursor-pointer text-gray-400 border-gray-300 text-hover-primary border-hover-primary"
                style="border-width: 1px;"
            >Добавить</div>
          </td>
          <td colspan="2" style="width: 100px" class="text-center">
            <div
                @click="filterToggle"
                class="rounded border border-dashed pt-6 pb-5 cursor-pointer text-primary border-success"
                style="border-width: 1px;"
            >
              <i class="ki-outline text-primary fs-3" :class="isFilter ? 'ki-cross' : 'ki-magnifier'"></i>
            </div>
          </td>
        </tr>
        <tr v-if="isFilter">
          <td colspan="8">
            <branch-departments-search :filter="filter"  @search="getDepartments"/>
          </td>
        </tr>
        <tr class="fw-bold fs-8 text-gray-400">
          <th style="width: 70px;">ID</th>
          <th>Название</th>
          <th>Руководитель</th>
          <th>Тип</th>
          <th>Привязано к</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in departments.data">
          <td v-html="item.id" class="w-80px"></td>
          <td>
            <div class="cursor-help" :title="item.title" style="-webkit-box-orient: vertical;-webkit-line-clamp: 1;display: -webkit-box;overflow: hidden;">
              {{item.title}}
            </div>
          </td>
          <td v-html="item.head"></td>
          <td v-html="this.getTypeName(item.type)" class="w-100px"></td>
          <td v-html="item.parent"></td>
          <td class="text-end w-20px">
            <span class="btn-activated cursor-pointer" @click="openModel(item.id, item.title, true)">
              <i class="ki-outline ki-notepad-edit text-primary fs-4"></i>
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <bootstrap5-pagination class="pagination-outline p-3 border-top" v-if="departments" :limit="3" :data="departments" @pagination-change-page="getDepartments"/>
  </div>
</template>

<script>
import BranchDepartmentsSearch  from "@/components/Branch/Search/BranchDepartmentsSearch.vue";
import {Bootstrap5Pagination}   from 'laravel-vue-pagination'

export default {
  name: 'BranchDepartmentsTable',
  components: { BranchDepartmentsSearch, Bootstrap5Pagination },
  props: {
    departments: null,
    filter:      null
  },
  data() {
    return {
      loaded:   false,
      isFilter: false
    }
  },
  mounted() {
    this.getDUsersHeadRequest()
    this.getDDepartmentsRequest()
    this.getDTerminalsRequest()
  },
  methods: {
    getDUsersHeadRequest() {
      this.$store.dispatch('headDicRequest')
    },
    getDTerminalsRequest() {
      this.$store.dispatch('terminalsDicRequest')
    },
    getDDepartmentsRequest() {
      this.$store.dispatch('departmentsDicRequest')
    },
    openModel(id, title, isEdit) {
      this.$store.dispatch('branchDepartmentCreateUpdateModel', {id:id, title:title, isEdit: isEdit})
      new bootstrap.Modal('#branchDepartmentCreateUpdateModel', {}).show()
    },
    getDepartments(val) {
      this.$emit('reloaded', val)
    },
    getTypeName(type) {
      if (type === 0) return 'Нет 1C'
      if (type === 1) return 'C 1C'
      if (type === 2) return 'Локальный'
    },
    filterToggle() {
      this.isFilter = !this.isFilter
      if (!this.isFilter) {
        this.filter.parent = null
        this.filter.title  = null
        this.filter.type   = null
        this.filter.head   = null
      }
    }
  },
  watch: {
    filter: {
      immediate: true,
      handler(val) {
        this.isFilter = val.parent !== null || val.type !== null || val.head !== null || val.title
      }
    }
  }
}
</script>

<style scoped>
.page-item {
  margin-right: .5rem;
  margin-bottom: .5rem;
}
</style>